import RequireAuthentication from '@/router/guards/RequireAuthentication'
import { lazy } from 'react'
// const GuideToMind = lazy(() => import('./pages/GuideToMind'))
// const GuideToMindCourse = lazy(
//   () => import('./pages/GuideToMindCourse/GuideToMindCourse'),
// )
const GuideToSleep = lazy(() => import('./pages/GuideToSleep'))
const MaternalSupport = lazy(() => import('./pages/MaternalSupport'))
const MaternalSupportCourse = lazy(
  () => import('./pages/MaternalSupportCourse'),
)
const MaternalSupportArticle = lazy(
  () => import('./pages/MaternalSupportArticle'),
)
const MaternalSupportQuiz = lazy(() => import('./pages/MaternalSupportQuiz'))
const MaternalSupportQuizResult = lazy(
  () => import('./pages/MaternalSupportQuizResult'),
)
const MaternalSupportPlanning = lazy(
  () => import('./pages/MaternalSupportPlanning'),
)
const MyConexaPlus = lazy(() => import('./pages/MyConexaPlus'))
const NonViolentCommunicationCourse = lazy(
  () => import('./pages/NonViolentCommunicationCourse'),
)

const MyConexaPlusRoutes = [
  <RequireAuthentication
    path="/conexa-plus"
    key="/Conexa Plus"
    exact
    component={MyConexaPlus}
  />,
  <RequireAuthentication
    path="/conexa-plus/guia-dormir"
    key="/conexa-plus/guia-dormir"
    exact
    component={GuideToSleep}
  />,
  <RequireAuthentication
    path="/conexa-plus/rede-de-apoio-materno"
    key="/conexa-plus/rede-de-apoio-materno"
    exact
    component={MaternalSupport}
  />,
  <RequireAuthentication
    path="/conexa-plus/rede-de-apoio-materno/:module/:course"
    key="/conexa-plus/rede-de-apoio-materno/:module/:course"
    exact
    component={MaternalSupportCourse}
  />,
  <RequireAuthentication
    path="/conexa-plus/rede-de-apoio-materno/:module/:course/artigo"
    key="/conexa-plus/rede-de-apoio-materno/:module/:course/artigo"
    exact
    component={MaternalSupportArticle}
  />,
  <RequireAuthentication
    path="/conexa-plus/rede-de-apoio-materno/:module/:course/quiz"
    key="/conexa-plus/rede-de-apoio-materno/:module/:course/quiz"
    exact
    component={MaternalSupportQuiz}
  />,
  <RequireAuthentication
    path="/conexa-plus/rede-de-apoio-materno/:module/:course/quiz/resultado"
    key="/conexa-plus/rede-de-apoio-materno/:module/:course/quiz/resultado"
    exact
    component={MaternalSupportQuizResult}
  />,
  <RequireAuthentication
    path="/conexa-plus/rede-de-apoio-materno/:module/:course/planejamento"
    key="/conexa-plus/rede-de-apoio-materno/:module/:course/planejamento"
    exact
    component={MaternalSupportPlanning}
  />,
  // <RequireAuthentication
  //   path="/conexa-plus/guia-para-a-mente"
  //   key="/conexa-plus/guia-para-a-mente"
  //   exact
  //   component={GuideToMind}
  // />,
  // <RequireAuthentication
  //   path="/conexa-plus/guia-para-a-mente/:course"
  //   key="/conexa-plus/guia-para-a-mente/:course"
  //   exact
  //   component={GuideToMindCourse}
  // />,
  <RequireAuthentication
    path="/conexa-plus/comunicacao-nao-violenta"
    key="/conexa-plus/comunicacao-nao-violenta"
    exact
    component={NonViolentCommunicationCourse}
  />,
]

export default MyConexaPlusRoutes
